import React, {Component} from 'react';
import {default as Checkbox} from '@sinclair-digital/sbg-storyline-components/src/components/forms/Checkbox';
import {arrayOf, func, shape} from 'prop-types';
import {packageTypeShape} from './PackageType';
import styles from './PackageTypes.scss';

class PackageTypes extends Component {
    static propTypes = {
        onChange: func.isRequired,
        packageTypes: arrayOf(shape(packageTypeShape)),
    };

    static defaultProps = {
        packageTypes: [],
    };

    renderPackageTypeCheckboxes = el => (
        <li key={el.value}>
            <Checkbox
                id={el.value}
                label={el.label}
                onChange={this.props.onChange}
                value={el.value}
                checked={el.checked}
            />
        </li>
    );

    render() {
        return (
            <div className={styles.packageTypes}>
                <ul className="sda-CheckboxList js-sda-PropertySettings-packageTypes">
                    {this.props.packageTypes.map(this.renderPackageTypeCheckboxes)}
                </ul>
            </div>
        );
    }
}

export default PackageTypes;
